import { produce } from 'immer';
import { handleActions } from 'redux-actions';
import ActionType from '@/actions/action-type';
import { IBusiness } from '@/types/business-types';
import { ISetAreaCodes, ISetBusiness, ISetMenus } from '@/actions/common-action';
import { IMenuData } from '@/types/menu-types';
import { IAreaCodes } from '@/types/common-types';

export interface ICommonState {
  business: IBusiness;
  menusData: IMenuData[];
  areaCodes: IAreaCodes[];
}

const defaultBusiness: IBusiness = {
  id: '',
  storeID: '',
  address: '',
  businessEmail: '',
  businessName: '',
  businessPhone: '',
  businessHighlight: '',
  types: [],
}

const initState: ICommonState = {
  business: defaultBusiness,
  menusData: [],
  areaCodes: [],
};

const actions: any = {};

actions[ActionType.SET_BUSINESS] = (state: ICommonState, action: ISetBusiness) => produce(state, draft => {
  if (action.business) {
    draft.business = action.business;
  }
});

actions[ActionType.SET_MENUS] = (state: ICommonState, action: ISetMenus) => produce(state, draft => {
  if (action.menusData) {
    draft.menusData = action.menusData;
  }
});

actions[ActionType.SET_CODES] = (state: ICommonState, action: ISetAreaCodes) => produce(state, draft => {
  if (action.areaCodes) {
    draft.areaCodes = action.areaCodes;
  }
});

export default handleActions(actions, initState);
